<template lang="">
  <Stack class="gap-2">
    <!-- FILTER -->
    <HStack class="gap-2">
      <b-input-group class="input-group-merge flex-1">
        <BFormInput
          v-model="searchText"
          debounce="300"
          class="form-control-merge"
          :placeholder="$t('myAccount.systemConfigs.errorMessages.searchTextPlaceholder')"
        />
        <b-input-group-append is-text>
          <BButton
            v-show="searchText"
            variant="flat-danger"
            class="btn-icon p-25"
            size="sm"
            @click="searchText = ''"
          >
            <IAmIcon icon="closeOutline" />
          </BButton>
        </b-input-group-append>
      </b-input-group>

      <div>
        <BButton
          class="px-75"
          variant="info"
          @click="() => $bvModal.show('modal-input-error-messages')"
        >
          {{ $t('ticket.addOrEdit') }}
        </BButton>
      </div>
    </HStack>
    <BTable
      ref="errorMessagesTableRef"
      :items="errorListRender"
      no-border-collapse
      :style="{ maxHeight: tableHeight }"
      sticky-header
      :fields="columns"
      striped
      hover
      bordered
      small
      responsive
      class="mb-0"
      show-empty
      :empty-text="searchText ? $t('myAccount.systemConfigs.errorMessages.searchEmptyData') : $t('myAccount.systemConfigs.errorMessages.emptyData')"
    >
      <template #cell(index)="data">
        {{ data.index + 1 }}
      </template>
      <template #cell(key)="data">
        <HStack class="hover-div">
          <pre class="text-wrap mb-0 text-dark fw-700">{{ data.item.key }}</pre>
          <IAmCopyTextButton :text="data.item.key" />
        </HStack>
      </template>
      <template #cell(viValue)="data">
        <HStack class="hover-div">
          {{ data.item.viValue }}
          <IAmCopyTextButton :text="data.item.viValue" />
        </HStack>
      </template>
      <template #cell(value)="data">
        <HStack class="hover-div">
          {{ data.item.value }}
          <IAmCopyTextButton :text="data.item.value" />
        </HStack>
      </template>
      <template #cell(actions)="data">
        <HStack center>
          <BButton
            v-b-tooltip.left.window.hover="$t('ticket.selectToAddOrEditList')"
            :variant="!errorMessagesToEdit.some(i => i.key === data.item.key) ? 'flat-info' : 'flat-success'"
            size="sm"
            class="rounded p-50"
            @click="onClickEdit(data.item)"
          >
            <IAmIcon
              v-if="!errorMessagesToEdit.some(i => i.key === data.item.key)"
              icon="pencil"
              size="14"
            />
            <IAmIcon
              v-else
              icon="tick"
              size="14"
            />
          </BButton>
        </HStack>
      </template>
    </BTable>
    <ModalInputErrorMessages
      :columns="columns"
      :errorList="errorMessagesToEdit"
      @clearErrorList="errorMessagesToEdit = []"
    />
  </Stack>
</template>
<script>
import { computed, ref } from '@vue/composition-api'
import {
  BFormInput, BTable, BButton, BInputGroup,
  BInputGroupAppend,
} from 'bootstrap-vue'

import store from '@/store'

export default {
  components: {
    BTable,
    BFormInput,
    BButton,
    BInputGroup,
    BInputGroupAppend,
    IAmCopyTextButton: () => import('@/components/IAmCopyTextButton.vue'),
    ModalInputErrorMessages: () => import('./ModalInputErrorMessages.vue'),
  },
  setup() {
    const ERROR_MESSAGES_KEY = 'errorMessage'
    const searchText = ref()
    const errorList = computed(() => store.getters['globalConfig/getConfig'](ERROR_MESSAGES_KEY)?.sort((a, b) => {
      if (a.key < b.key) return -1
      if (a.key > b.key) return 1
      return 0
    }))
    const errorListRender = computed(() => errorList.value?.filter(item => {
      if (!searchText.value) return true
      const searchTextValue = searchText.value.replaceAll('_', ' ').toLowerCase().trim()
      return item.key.replaceAll('_', ' ').toLowerCase().includes(searchTextValue)
          || item.viValue.toLowerCase().includes(searchTextValue)
          || item.value.toLowerCase().includes(searchTextValue)
    }))
    const columns = [
      { key: 'index', label: 'index', tdClass: 'text-right width-50' },
      { key: 'key', label: 'key', tdClass: 'width-400' },
      { key: 'viValue', label: 'vi' },
      { key: 'value', label: 'en' },
      { key: 'actions', label: 'actions', tdClass: 'fit-content' },
    ]
    const errorMessagesTableRef = ref()
    const tableHeight = computed(() => {
      const offsetTop = errorMessagesTableRef.value?.$el?.offsetTop ?? 0
      return offsetTop ? `calc(100vh - ${offsetTop}px - 100px)` : '70vh'
    })

    const errorMessagesToEdit = ref([])
    const onClickEdit = item => {
      const index = errorMessagesToEdit.value.findIndex(i => i.key === item.key)
      if (index > -1) {
        errorMessagesToEdit.value.splice(index, 1)
      } else {
        errorMessagesToEdit.value.push(item)
      }
    }
    return {
      errorListRender,
      columns,
      searchText,
      errorMessagesTableRef,
      tableHeight,
      onClickEdit,
      errorMessagesToEdit,
    }
  },
}
</script>
<style lang="scss" scoped>
.hover-div {
  .btn {
    opacity: 0;
  }
  &:hover {
    .btn {
      opacity: 1;
    }
  }
}

::v-deep .table {
  .width-400 {
    width: 400px;
  }
  .width-50 {
    max-width: 50px;
  }
}

</style>
